import * as actionTypes from '../constants/actionTypes';
import {getApiConfig} from '../utilities';
import {hashHistory} from 'react-router';
import * as actions from '../actions';
import {resetCategories} from "../components/NewScope/newScopeActions";
import {loadingDialog_show} from "../actions";

// We only have one endpoint. We use POST to authenticate the user and GET to refresh the logged in user's
// authentication token.
const {get, post} = getApiConfig('auth/login');

let redirectTo = {redirectAfterLogin: null};

export function getRedirectTo() {
  return redirectTo;
}

export function setRedirectTo(value) {
  redirectTo = value;
}

export function login(...args) {
  const type = actionTypes.LOGIN;

  if (args.length === 2) {
    const {email, password} = args[0];
    return {
      type,
      payload: post({email, password})
    };
  }

  return {
    type,
    payload: get()
  };
}


export function logout() {
  return {
    type: actionTypes.LOGOUT,
    payload: {}
  }
}

export function showSwitchUserWindow(show) {
  return {
    type: actionTypes.SHOW_SWITCH_USER_WINDOW,
    payload: {show}
  }
}

export function toggleWarningOff() {
  return (dispatch, getState) => {
    getApiConfig('auth/DoNotShowLinkWarning').post();
    dispatch({
      type: actionTypes.DO_NOT_SHOW_LINK_WARNING
    });
  }
}

export function requireFabricatorAdmin() {
  return (dispatch, getState) => {
    let state = getState();
    return new Promise((resolve, reject) => {
      if (state.auth.fabricatorId > 0) {
        resolve();
      } else {
        dispatch(actions.messageBox_Show(true, "error", "Not a Fabricator Admin", "Your account doesn't have permissions to access this page.", [{
          text: 'Log In',
          subtext: 'with a new account',
          onClick: () => {
            dispatch(actions.messageBox_Show()); //reset to default props (not visible by default)
            hashHistory.push('/login');
          }
        }, {
          text: 'Return',
          subtext: 'to the hub',
          onClick: () => {
            dispatch(actions.messageBox_Show())
            hashHistory.push('/');
          }
        }]));
        reject();
      }
    });
  }
}

/**
 * Returns the protected areas and their rights for a given user
 * @param userId
 * @param customerBaseId
 * @param redirectToMainPageAfterSwitch {boolean}
 */
export function getProtectedAreasByUser(userId, customerBaseId, redirectToMainPageAfterSwitch = false) {
  return dispatch => {
    dispatch(loadingDialog_show(true, "Loading...", 'Loading user\'s rights...'));

    dispatch({
      type: actionTypes.GET_PROTECTED_AREAS_BY_USER_REQUEST,
      payload: {userId, customerBaseId}
    });
    var url = 'Auth/ProtectedAreas/' + userId + (customerBaseId > 0 ? "/" + customerBaseId : "");
    console.log(url);
    getApiConfig(url)
      .get()
      .then(data => {
        dispatch({type: actionTypes.POPUP_IN_PROGRESS, payload: {show: false}});

        if (data && data.masterFabricatorIds && data.masterFabricatorIds.leadForm && !data.masterFabricatorIds.leadform) {
          data.masterFabricatorIds.leadform = data.masterFabricatorIds.leadForm;
          delete data.masterFabricatorIds.leadForm;
        }

        dispatch({
          type: actionTypes.GET_PROTECTED_AREAS_BY_USER_RESPONSE,
          payload: data
        });

        dispatch(resetCategories());
        if (redirectToMainPageAfterSwitch) {
          hashHistory.push("/");
        }
      });
  }
}


